export enum PrescriptionResponseStateEnum {
  NotAccept = 1,
  Accept = 2,
  Tahvil = 3,
  NoTahvil = 4,
  Waiting = 5,
}

// export enum PrescriptionCostTypesEnum {
//   Free = 0,
//   Normal = 1,
//   Special = 2,
//  // Vip = 3,
// }
